export default "__VITE_ASSET__0CfUFfuS__";